<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <v-avatar color="primary" size="80">
                <span class="white--text" style="font-size: 25pt">
                  {{ firstLetter }}
                </span>
              </v-avatar>
            </div>

            <div class="text-center mt-2">
              <h3 class="grey--text text--darken-2">{{ user.nome }}</h3>
              <h4 class="grey--text">{{ getUser.rule.nome }}</h4>
              <h4 class="grey--text">
                {{ user.telefone | BrazilianPhone }}
              </h4>
              <h4 class="grey--text">{{ user.email }}</h4>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import http from "@/services/http";
import phoneMixin from "@/mixins/phoneMixin";

export default {
  name: "Perfil",
  mixins: [phoneMixin],
  data() {
    return {
      user: []
    };
  },

  mounted() {
    this.fetchView("Perfil");
    this.getUserData();
  },

  computed: {
    ...mapGetters({
      getUser: "getUser"
    }),

    firstLetter() {
      return this.user?.nome?.charAt(0);
    }
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    }),

    async getUserData() {
      try {
        const { data } = await http.get(
          `/sistemas/usuarios/${this.getUser.id}`
        );

        this.user = data;
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Não foi possível buscar as informações do perfil"
        });
      }
    }
  }
};
</script>
